import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';

import { useShowSubscriber } from 'modules/for-verification/hooks';
import Pagination from 'partial/components/Pagination';
import Table from 'partial/components/Table';
import { useRateHistory } from '../hooks';

function RateHistory() {
  const { id } = useParams();
  const [, subscriber] = useShowSubscriber(id);
  const orgUuid = subscriber?.organization?.uuid;
  const [filter, setFilter] = useState({ page: 1 });
  const [isLoading, list, meta] = useRateHistory(filter, orgUuid);

  const format = [
    {
      label: 'date',
      key: (item) => (
        <span>{dayjs(item?.created_at).format('MMM DD, YYYY hh:mm A')}</span>
      ),
    },
    {
      label: 'rate',
      key: 'rate_per_sms',
    },
  ];

  return (
    <div className="h-full flex flex-col space-y-10">
      <Table isLoading={isLoading} data={list} format={format} />
      <div className="px-3">
        <Pagination value={meta} onChange={setFilter} />
      </div>
    </div>
  );
}

export default RateHistory;
